import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { SeverityTag } from '@src/app/components/status/types';
import { normalizeDictionaryValue } from '@src/app/utils';
import { USER_STATUS } from '@src/app/constants';

@Component({
  selector: 'users-status',
  standalone: true,
  imports: [TagModule],
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusComponent {
  @Input() set value(value: boolean) {
    switch (value) {
      case false:
        this.severity = 'danger';
        break;

      case true:
        this.severity = 'success';
        break;

      default:
        this.severity = 'warning';
        break;
    }

    this.status = normalizeDictionaryValue(value ? 1 : 0, USER_STATUS);
  }

  status?: string;
  severity?: SeverityTag;
}
